class AppPopup extends BasePopup {
}
